class AppPopup extends BasePopup {
}
